import React, { useState } from "react"

import Tile from "../../components/structure/tile/tile"
import Title from "../../components/structure/title/title"
import Navigation from "../../components/ui/navigation/navigation"

import DevelopmentTab from "./_components/development-tab"
import EnquiryQueueTab from "./_components/enquiry-queue-tab"
import EnquiryQueueWebsiteTab from "./_components/enquiry-queue-website-tab"
import { readLocalStorage, writeLocalStorage } from "./_components/storage"

import "./enquiry-ingest.scss"
// Reuse the AI-tools panel styles for the inputs/result blocks so this page
// matches the email-drawer panel aesthetic.
import "../communications/_components/ai-tools/panel.scss"
// Reuse the mailboxes-table SCSS for the queue tab so the table matches the
// monitored-mailboxes look exactly.
import "../communications/mailboxes.scss"

const ACTIVE_TAB_KEY = "enquiry-ingest:active-tab"
const TABS = {
	DEVELOPMENT: "DEVELOPMENT",
	QUEUE: "QUEUE",
	QUEUE_WEBSITE: "QUEUE_WEBSITE",
}

/**
 * Enquiry Ingest page — wraps the two tabs (Development authoring surface
 * and Enquiry Queue feedback loop) in a single Tile. The active tab is
 * persisted to localStorage so a refresh keeps you where you were.
 */
function EnquiryIngest() {
	const [activeTab, setActiveTab] = useState(() =>
		readLocalStorage(ACTIVE_TAB_KEY, TABS.DEVELOPMENT)
	)

	const onTabClick = (id) => {
		setActiveTab(id)
		writeLocalStorage(ACTIVE_TAB_KEY, id)
	}

	return (
		<Tile fullPage={true}>
			<Title className="flex">
				<h1>Enquiry ingest</h1>
			</Title>

			<div className="enquiry-ingest-tabs">
				<Navigation
					links={[
						{ id: TABS.DEVELOPMENT, label: "Development" },
						{ id: TABS.QUEUE, label: "Enquiry Queue (emails)" },
						{ id: TABS.QUEUE_WEBSITE, label: "Enquiry Queue (website)" },
					]}
					active={activeTab}
					onClick={onTabClick}
				/>
			</div>

			{activeTab === TABS.DEVELOPMENT && <DevelopmentTab />}
			{activeTab === TABS.QUEUE && <EnquiryQueueTab />}
			{activeTab === TABS.QUEUE_WEBSITE && <EnquiryQueueWebsiteTab />}
		</Tile>
	)
}

export default EnquiryIngest
